import React, { useEffect, useRef, useState } from "react";
import "./upload-file.css"; // Add your custom CSS here
import { useAuth } from "../auth/auth-context";
import { UploadFileViewModel } from "./upload-file.view-model";
import UploadButton from "src/components/molecules/upload-button/upload-button";
import { IFileInfo } from "src/types/models/apiModels";

interface UploadFileProps {
	label: string;
	file?: IFileInfo;
	onUploadSuccess: (file: IFileInfo | undefined) => void; // Callback to notify parent component
	onClear?: () => void;
}

const UploadFile: React.FC<UploadFileProps> = ({
	label,
	onUploadSuccess,
	onClear,
	file,
}) => {
	const { user } = useAuth(); // Extract user from useAuth hook
	const [fileSrc, setFileSrc] = useState<IFileInfo | undefined>(undefined);
	const viewModel = useRef<UploadFileViewModel | null>(null);
	useEffect(() => {
		if (user && user.accessToken) {
			viewModel.current = new UploadFileViewModel(user.accessToken);
		}
	}, [user]);

	useEffect(() => {
		onUploadSuccess(fileSrc);
	}, [fileSrc]);

	const handleFileChange = async (uploadedFile: IFileInfo) => {
		if (uploadedFile) {
			setFileSrc(() => uploadedFile);
		}
	};

	const handleClear = async () => {
		setFileSrc(() => undefined);
		if (onClear) {
			onClear();
		}
	};

	return (
		<>
			<div className="flex flex-col items-start justify-center gap-2 ">
				<span className="block text-sm font-Poppins font-medium text-gray-700">
					{label}
				</span>
				<UploadButton
					buttonType="File"
					onUploadSuccess={handleFileChange}
					onClear={handleClear}
				></UploadButton>
			</div>
		</>
	);
};

export default UploadFile;
